<template>
  <b-card
    v-if="data"
    class="card-congratulation-medal"
  >
    <h5>Les Projets Gagnés  de votre entreprise</h5>
    <b-card-text class="font-small-3">
      Vous devez sélectionner l'année concernée pour visualiser les informations
    </b-card-text>
    <h3 class="mb-75 mt-2 pt-50">
      <b-link>{{ amountToCurrency(data.won_amount) }}</b-link>
    </h3>
    <b-dropdown
          text="Sélectionner l'année"
          class="budget-dropdown"
          variant="primary"
        >
          <b-dropdown-item
            v-for="year in years"
            :key="year"
            @click="$emit('fetchData', year)"
          >
            {{ year }}
          </b-dropdown-item>
        </b-dropdown>
  </b-card>
</template>

<script>
import {
  BCard, BCardText, BLink, BDropdown, BDropdownItem
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { amountToCurrency } from "@/utils/formatAmount";

export default {
  name: "StatisticInfoCard",
  components: {
    BCard,
    BCardText,
    BLink,
    BDropdown,
    BDropdownItem,
  },
  directives: {
    Ripple,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    years: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    amountToCurrency,
  },
}
</script>